/*
 * File: /src/store/modules/surveys.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import SurveyService from 'src/services/surveyService';

const state = {
  surveys: undefined
};

const getters = {
  getSurveys: (state) => state.surveys,
};
const actions = {
  async fetchSurveys({ commit, state, rootGetters }) {
    // Only load the data once
    if (state.surveys == undefined) {
      return SurveyService.fetchAll()
      .then(r => {
        commit('setSurveys', r.data);
      });
    }
  },
  unloadSurveys({ commit }) {
    commit('setSurveys', undefined);
  }
};
const mutations = {
  setSurveys(state, surveys) {
    state.surveys = surveys;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
